// extracted by mini-css-extract-plugin
module.exports = {"img":"ServiceTemporarilyUnavailable_img__ngAvJ","title":"ServiceTemporarilyUnavailable_title__1haQ_","desc":"ServiceTemporarilyUnavailable_desc__1B1zm"};